import React from 'react';
import JobReports from '../JobReports';

const DailyReports = (props) => <JobReports {...props} reportType="jobdaily" />;

export default DailyReports;
